import { useGallery, useWindowEvent, AspectRatio, Image } from '@ccg/core';
import React$1, { useState, useRef, useEffect } from 'react';
import PropTypes$1 from 'prop-types';
import Typography$1 from '../../basics/Typography/Typography.js';
import MediaContent$1 from '../MediaContent/MediaContent.js';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Controls$1 from './subcomponents/Controls/Controls.js';
import StyledGallery from './Gallery.style.js';
import Slider$1 from './subcomponents/Slider/Slider.js';
import Overview$1 from './subcomponents/Overview/Overview.js';
import Modal$1 from '../Modal/Modal.js';

const Gallery = ({
  images,
  caption,
  imageShadow
}) => {
  const {
    index,
    isOverview,
    handlePrev,
    handleNext,
    handleChange,
    toggleOverview
  } = useGallery(images);
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  useWindowEvent('keydown', ({
    key
  }) => {
    if (key === 'ArrowRight') return handleNext();
    if (key === 'ArrowLeft') return handlePrev();
    if (key === 'o') return toggleOverview();
    if (key === 'Escape') return setIsOpen(false);
  });
  useEffect(() => {
    if (isOpen) {
      disableBodyScroll(ref.current);
    } else {
      enableBodyScroll(ref.current);
    }

    return () => {
      clearAllBodyScrollLocks();
    };
  }, [isOpen]);
  const slicedImages = images.slice(0, 3);
  return /*#__PURE__*/React$1.createElement(StyledGallery, null, /*#__PURE__*/React$1.createElement(MediaContent$1, {
    caption: caption,
    framerCaption: `${images.length} Images`,
    noReveal: true
  }, /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    className: "gallery__button",
    "aria-label": "Open Gallery",
    onClick: () => setIsOpen(true)
  }, /*#__PURE__*/React$1.createElement(AspectRatio, {
    ratio: "4:3",
    className: "gallery__ratio"
  }, slicedImages.slice(0).reverse().map(({
    id: imageId,
    src,
    srcset,
    alt
  }) => /*#__PURE__*/React$1.createElement(Image, {
    key: imageId,
    src: src,
    srcset: srcset,
    sizes: "50vw",
    alt: alt,
    lazy: true
  }))), /*#__PURE__*/React$1.createElement("div", {
    className: "gallery__layer"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "span",
    transform: "uppercase"
  }, "View all"), /*#__PURE__*/React$1.createElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M8 24v8H0v-8h8zm12 0v8h-8v-8h8zm12 0v8h-8v-8h8zM8 12v8H0v-8h8zm12 0v8h-8v-8h8zm12 0v8h-8v-8h8zM8 0v8H0V0h8zm12 0v8h-8V0h8zm12 0v8h-8V0h8z",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React$1.createElement(Modal$1, {
    isOpen: isOpen,
    ref: ref
  }, !isOverview && images.length > 0 && /*#__PURE__*/React$1.createElement(Slider$1, {
    images: images,
    imageShadow: imageShadow,
    currentIndex: index,
    handleChange: handleChange
  }), isOverview && images.length > 0 && /*#__PURE__*/React$1.createElement(Overview$1, {
    images: images,
    imageShadow: imageShadow,
    currentIndex: index,
    handleChange: handleChange
  }), /*#__PURE__*/React$1.createElement(Controls$1, {
    isOverview: isOverview,
    handleNext: handleNext,
    handlePrevious: handlePrev,
    handleClose: () => setIsOpen(false),
    handleOverview: () => toggleOverview(),
    handleChange: handleChange,
    currentIndex: index,
    currentCaption: images[index] && images[index].caption,
    numberOfBullets: images.length
  })));
};

Gallery.propTypes = {
  caption: PropTypes$1.string,
  imageShadow: PropTypes$1.bool,
  images: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired
};
Gallery.defaultProps = {
  caption: null,
  imageShadow: false
};

export default Gallery;
